import { render } from "./survey.vue?vue&type=template&id=2623b2e3&scoped=true"
import script from "./survey.vue?vue&type=script&lang=js"
export * from "./survey.vue?vue&type=script&lang=js"

import "./survey.vue?vue&type=style&index=0&id=2623b2e3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2623b2e3"]])

export default __exports__